import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import flipkart_logo from "../../assets/flipkart-logo.svg";
import amazon_logo from "../../assets/amazon_logo2.svg";
import croma_logo from "../../assets/croma_logo.svg";
import jiomart_logo from "../../assets/jiomart-logo.svg";
import CurrencySymbol from "../common/CurrencySymbol/CurrencySymbol";
import CustomizedRating from "../common/Rating/Rating";
import { Container } from "@mui/material";

/* export default function ProductCard(props) {
  const { product, addToCart } = props; */

type Props = {
  otherStoreData: any;
};

const OtherStoreInfoCard: React.FC<Props> = (props) => {
  return (
    <Container maxWidth="xs" style={{ marginLeft: 0 }}>
      <Card
        sx={{
          minWidth: "230px",
          maxWidth: "230px",
          /*   maxWidth: "320px",
          maxHeight: "220px", */
          minHeight: "190px",
          borderRadius: "8px",
          background:
            "linear-gradient(white, white) padding-box,linear-gradient(180deg, #d3131d 0%, #160f92 100%) border-box",
          border: "0.25px solid transparent",
          textAlign: "center",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            id={`retailers_logo${props?.otherStoreData?.id}`}
            src={
              props?.otherStoreData?.retailer === "FLIPKART"
                ? flipkart_logo
                : props?.otherStoreData?.retailer === "AMAZON"
                ? amazon_logo
                : props?.otherStoreData?.retailer === "CROMA"
                ? croma_logo
                : jiomart_logo
            }
            alt="Logo of the retailer"
            height={"30px"}
            width={"100px"}
            style={{ marginRight: "8px", width: "100px" }}
            onClick={() => {
              window.open(
                props?.otherStoreData?.product_url_retailer,
                "_blank"
              );
            }}
          />
          <Typography
            className="product-price"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <CurrencySymbol
              currencyCode="INR"
              amount={props?.otherStoreData?.product_discounted_price}
            />

            <span className="product-discount">
              ({props?.otherStoreData?.product_discount_percentage}% off)
            </span>
          </Typography>
          {props?.otherStoreData?.product_rating_star > 0 && (
            <div className="rating-div">
              <CustomizedRating
                rating_star={parseFloat(
                  props?.otherStoreData?.product_rating_star
                )}
                rating_count={props?.otherStoreData?.product_rating_count}
                isRetailer={false}
              />
            </div>
          )}
        </CardContent>
        <CardActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            size="small"
            className="shop-now-button"
            onClick={() => {
              window.open(
                props?.otherStoreData?.product_url_retailer,
                "_blank"
              );
            }}
          >
            Shop now
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};

export default OtherStoreInfoCard;
